import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "Ръката на майстора",
    text: "Всяка стъбло, всяко листо е подредено на ръка. Айлян работи бавно и внимателно, докато композицията не проговори сама.",
  },
  {
    n: "02",
    title: "Красота без край",
    text: "Изкуствените цветя запазват формата и цвета си завинаги — без вода, без грижа, без увяхване. Само тиха, постоянна красота.",
  },
  {
    n: "03",
    title: "За вашето пространство",
    text: "Различни размери за различни моменти — от нежен акцент на масата до внушителна композиция за специален повод.",
  },
];

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: i * 0.1 } }),
};

export default function Manifesto() {
  return (
    <section id="manifesto" className="max-w-[1400px] mx-auto px-6 lg:px-12 py-28 lg:py-40" data-testid="manifesto">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-28">
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="text-xs uppercase tracking-[0.3em] text-clay font-medium mb-6"
          >
            Историята
          </motion.p>
          <motion.h2
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            variants={reveal}
            className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight text-ink"
          >
            Изкуство, родено от търпение и любов към детайла
          </motion.h2>
          <motion.div
            initial={{ opacity: 0, scale: 1.05 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1 }}
            className="mt-12 overflow-hidden rounded-xl"
          >
            <img
              src="https://images.pexels.com/photos/5414317/pexels-photo-5414317.jpeg"
              alt="Ръцете на Айлян изработват цветя"
              className="w-full h-[360px] object-cover"
            />
          </motion.div>
        </div>

        <div className="lg:col-span-7 flex flex-col">
          {chapters.map((c, i) => (
            <motion.div
              key={c.n}
              custom={i}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-80px" }}
              variants={reveal}
              className="border-t border-line py-10 lg:py-14 grid grid-cols-[auto_1fr] gap-8 lg:gap-14"
            >
              <span className="font-serif text-5xl lg:text-7xl text-clay/40 leading-none">{c.n}</span>
              <div>
                <h3 className="font-serif text-2xl lg:text-3xl text-ink mb-4">{c.title}</h3>
                <p className="text-stone font-light text-base lg:text-lg leading-relaxed max-w-xl">{c.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
